import { createPinia } from "pinia";
import { createApp, h } from "vue";
import singleSpaVue from "single-spa-vue";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";

import App from "./amb-cve-assistant/App.vue";
import { configureAuth } from "./amb-cve-assistant/services/cveApi";
import { createAppRouter } from "./amb-cve-assistant/router/router";
import type { AmbCveAssistantProps } from "./interfaces";

const vuetify = createVuetify({ components, directives });

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App);
    },
  },
  handleInstance(app, props: AmbCveAssistantProps) {
    app.use(createPinia());
    app.use(vuetify);
    app.use(createAppRouter());

    const auth = props.authInterface || window.authInterface;
    if (auth?.getJwt) {
      configureAuth(() => auth.getJwt());
    } else {
      configureAuth(async () => "local-dev-token");
    }
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
